import React from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from 'react-router-dom';

import PageNotFound from '~/commons/components/PageNotFound.jsx';
import { Nav, permittedLinks } from './layout';
import {
  RouteUsers,
  RouteStocks,
  RouteDesigns,
  RouteConfigs,
  RouteConsignments,
  RouteOrders,
  RouteQuotations,
  RouteExchangeRates,
  RouteTaxations,
  RouteShowrooms,
  RouteTerms,
  RouteServices,
  RouteCollections,
  RouteCollaborators,
} from './routes';

const routers = [
  { path: '/admin/users', router: <RouteUsers /> },
  { path: '/admin/designs', router: <RouteDesigns /> },
  { path: '/admin/stocks', router: <RouteStocks /> },
  { path: '/admin/collections', router: <RouteCollections /> },
  { path: '/admin/collaborators', router: <RouteCollaborators /> },
  { path: '/admin/quotations', router: <RouteQuotations /> },
  { path: '/admin/consignments', router: <RouteConsignments /> },
  { path: '/admin/orders', router: <RouteOrders /> },
  { path: '/admin/exchange-rates', router: <RouteExchangeRates /> },
  { path: '/admin/taxations', router: <RouteTaxations /> },
  { path: '/admin/showrooms', router: <RouteShowrooms /> },
  { path: '/admin/terms', router: <RouteTerms /> },
  { path: '/admin/services', router: <RouteServices /> },
  { path: '/admin/configs', router: <RouteConfigs /> },
];

const Admin = () => (
  <div className="container-fluid h-100">
    <div className="row h-100">
      <Router>
        <Nav />
        <div className="col">
          <div className="px-4">
            <Switch>
              <Route path="/admin" exact>
                <Redirect
                  to={
                    permittedLinks?.[0].to
                    || '/admin/users/self'
                  }
                />
              </Route>
              {routers.reduce((acc, cur) => {
                const cleanPath = cur.path.replace(/\/:.+/g, '');
                const found = permittedLinks
                  .find(({ to }) => to === cleanPath);
                if (!found) return acc;
                return [
                  ...acc,
                  <Route key={cur.path} path={cur.path}>
                    {cur.router}
                  </Route>,
                ];
              }, [])}

              <Route path="*">
                <PageNotFound vAlign />
              </Route>
            </Switch>
          </div>
        </div>
      </Router>
    </div>
  </div>
);

export default Admin;
